import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { Button, Chip, Grid } from "@material-ui/core";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from "moment";
import { fetchConToken } from "../../helpers/fetch";
import { useDispatch, useSelector } from "react-redux";
import { startAlerta } from "../../actions/ui/alertas";
import { useHistory, useLocation } from "react-router";
import { fetchFiltrosGuardados } from "../../actions/indicadores";

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: "relative",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    chips: {
        margin: "0.20rem"
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function FiltrosGuardadosModal({ abrirModal, setAbrirModal, filtrosGuardados }) {
    const classes = useStyles();
    const dispatch = useDispatch()
    const query = useQuery()
    const history = useHistory()

    const [expanded, setExpanded] = React.useState(false);

    const seccionales = useSelector((state) => state.seccionales.items);
    const provincias = useSelector((state) => state.provincias.items);
    const localidades = useSelector((state) => state.localidades.items);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleClose = () => {
        setAbrirModal(false);
    };

    const handleDeleteFiltro = async (id) => {
        try {
            await fetchConToken(`Filtros/${id}`, null, "DELETE")
            dispatch(startAlerta("Filtro eliminado correctamente", "success", "Correcto"))
            dispatch(fetchFiltrosGuardados());

        } catch (error) {
            dispatch(startAlerta("Error al eliminar", "error", "Error"))
        }
    }

    const handleSetFilters = (data) => {
        if (data.seccionales) {
            query.set('seccionales', data.seccionales.join(','))
        }else{
            query.delete('seccionales')
        }
        if (data.provincias) {
            query.set('provincias', data.provincias.join(','))
        }else{
            query.delete('provincias')
        }
        if (data.localidades) {
            query.set('localidades', data.localidades.join(','))
        }else{
            query.delete('localidades')
        }
        if (data.fecNacDesde !== null && data.fecNacHasta !== null) {
            query.set('fecNacDesde', (data.fecNacDesde).format('YYYY-MM-DD'))
            query.set('fecNacHasta', moment(data.fecNacHasta).format('YYYY-MM-DD'))
        }else{
            query.delete('fecNacDesde')
            query.delete('fecNacHasta')
        }

        if (data.fecAltaDesde !== null && data.fecAltaHasta !== null) {
            query.set('fecAltaDesde', moment(data.fecAltaDesde).format('YYYY-MM-DD'))
            query.set('fecAltaHasta', moment(data.fecAltaHasta).format('YYYY-MM-DD'))
        }else{
            query.delete('fecAltaDesde')
            query.delete('fecAltaHasta')
        }

        if(data.fecBajaDesde !== null && data.fecBajaHasta !== null){
            query.set('fecBajaDesde', moment(data.fecBajaDesde).format('YYYY-MM-DD'))
            query.set('fecBajaHasta', moment(data.fecBajaHasta).format('YYYY-MM-DD'))
        }else{
            query.delete('fecBajaDesde')
            query.delete('fecBajaHasta')
        }
        history.push(`?${query.toString()}`)
    }

    return (
        <div>
            <Dialog
                fullScreen
                open={abrirModal}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Filtros guardados
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Grid container style={{ padding: "1rem" }}>
                    {
                        filtrosGuardados.length === 0 &&
                        <Grid item xs={12}>
                            No hay filtros guardados...
                        </Grid>
                    }
                    <Grid item xs={12}>
                        {
                            filtrosGuardados.map(filtro => {
                                let filtrosData = JSON.parse(filtro.seteo)
                                return (
                                    <Accordion key={filtro.id} expanded={expanded === `filtro-${filtro.id}`} onChange={handleChange(`filtro-${filtro.id}`)}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls={`panel${filtro.id}bh-content`}
                                            id={`panel${filtro.id}bh-header`}
                                        >
                                            <Typography className={classes.heading}>{filtro.nombre}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container>
                                            {
                                                    filtrosData.parentescos !== null &&
                                                    <Grid item xs={12}>
                                                        <Chip className={classes.chips} label={"Solo titulares"} />
                                                    </Grid>
                                                }
                                                {
                                                    filtrosData.fecNacDesde !== null && filtrosData.fecNacHasta !== null &&
                                                    <Grid item xs={12}>
                                                        <Typography>Fecha de nacimiento</Typography>
                                                        <Chip className={classes.chips} label={moment(filtrosData.fecNacDesde).format("DD/MM/YYYY")} />
                                                        <Chip className={classes.chips} label={moment(filtrosData.fecNacHasta).format("DD/MM/YYYY")} />
                                                    </Grid>
                                                }

                                                {
                                                    filtrosData.fecAltaDesde && filtrosData.fecAltaHasta &&
                                                    <Grid item xs={12}>
                                                        <Typography>Fecha de alta</Typography>
                                                        <Chip className={classes.chips} label={moment(filtrosData.fecAltaDesde).format("DD/MM/YYYY")} />
                                                        <Chip className={classes.chips} label={moment(filtrosData.fecAltaHasta).format("DD/MM/YYYY")} />
                                                    </Grid>
                                                }

                                                {
                                                    filtrosData.fecBajaDesde && filtrosData.fecBajaHasta &&
                                                    <Grid item xs={12}>
                                                        <Typography>Fecha de baja</Typography>
                                                        <Chip className={classes.chips} label={moment(filtrosData.fecBajaDesde).format("DD/MM/YYYY")} />
                                                        <Chip className={classes.chips} label={moment(filtrosData.fecBajaHasta).format("DD/MM/YYYY")} />
                                                    </Grid>
                                                }

                                                {
                                                    filtrosData.seccionales !== null &&
                                                    <Grid item xs={12} style={{ marginTop: "1rem" }}>
                                                        <Typography>Seccionales</Typography>
                                                        {
                                                            filtrosData.seccionales.map(s => {
                                                                return <Chip key={s} className={classes.chips} label={`Seccional: ${seccionales.find(sec => sec.id_seccional.toString() === s).descripcion_seccional}`} />

                                                            })
                                                        }
                                                    </Grid>
                                                }
                                                {
                                                    filtrosData.provincias !== null &&
                                                    <Grid item xs={12} style={{ marginTop: "1rem" }}>
                                                        <Typography>Provincias</Typography>
                                                        {
                                                            filtrosData.provincias.map(s => {
                                                                return <Chip key={s} className={classes.chips} label={`Provincia: ${provincias.find(prov => prov.id_provincia.toString() === s).descripcion_provincia}`} />

                                                            })
                                                        }
                                                    </Grid>
                                                }
                                                {
                                                    filtrosData.localidades !== null &&
                                                    <Grid item xs={12} style={{ marginTop: "1rem" }}>
                                                        <Typography>Localidades</Typography>
                                                        {
                                                            filtrosData.localidades.map(s => {
                                                                return <Chip key={s} className={classes.chips} label={`Localidad: ${localidades.find(loc => loc.id_localidad.toString() === s).descripcion_localidad}`} />

                                                            })
                                                        }
                                                    </Grid>
                                                }
                                                <Grid item xs={12} style={{ textAlign: "right" }}>
                                                    <Button color="secondary" variant="contained" style={{ marginRight: "0.5rem" }} onClick={() => handleDeleteFiltro(filtro.id)}>Eliminar</Button>
                                                    <Button color="primary" variant="contained" onClick={() => handleSetFilters(filtrosData)}>Ver</Button>
                                                </Grid>

                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                )
                            })
                        }
                    </Grid>
                </Grid>

            </Dialog>
        </div>
    );
}
